module.exports = __webpack_public_path__ + "img/SYM07.5158dce4.gif";